<template>
    <div class="wrapper">
        <parallax class="section page-header header-filter" :style="headerStyle">
            <div class="container text-center">
                <div class="md-layout">
                    <!-- <div class="md-layout-item md-size-500 md-small-size-70 md-xsmall-size-100">
                        <vue-friendly-iframe src="https://socketio.bemyvega.com"></vue-friendly-iframe>
                    </div> -->
                    <iframe src="https://socketio.bemyvega.com" width="90%" height="60%" frameborder="0"> </iframe>
                </div>
            </div>
        </parallax>
    </div>
</template>

<script>
import Vue from "vue";
import VueFriendlyIframe from "vue-friendly-iframe";

Vue.use(VueFriendlyIframe);

export default {
    bodyClass: "landing-page",
    props: {
        header: {
            type: String,
            default: require("@/assets/img/fondo2.png")
        }
    },
    computed: {
        headerStyle() {
            return {
                backgroundImage: `url(${this.header})`
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    height: 45rem;
    margin-top: 4rem;
}
.md-layout {
    height: 45rem;
}
.md-layout-item {
    height: 45rem;
}
// .vue-friendly-iframe {
//     width: 100%;
//     height: 60rem;
// }
// .vue-friendly-iframe > iframe {
//     width: 100%;
//     height: 60rem;
// }
iframe {
    border-radius: 1rem;
    margin: auto;
    height: 70% !important;
}

@media screen and (min-width: 1200px) {
    iframe {
        width: 100%;
        height: 90% !important;
    }
}
</style>
